import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteAlertById } from '../../services/AlertsService';
import { AlertDetails, AlertDeleteRequest } from '../../types/Alerts';

type Result = UseMutationResult<AlertDetails, Error, AlertDeleteRequest>;

function useDeleteAlertById(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteAlertById, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['alerts'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteAlertById;
